<svelte:options runes={false} />

<script>
  import CurrencySelect from './CurrencySelect.svelte';

  export let draftTitle;
  export let draftDueDate;
  export let draftTaxPercent;
  export let draftCurrency;
  export let currencyLocked;
  export let draftMinimumRate;
  export let savingInvoiceDraft;
  export let onSaveDraft;
  export let editingHourBitId;
  export let bitLabel;
  export let bitHours;
  export let bitFixedCost;
  export let bitDescription;
  export let bitReported;
  export let savingHourBit;
  export let onSaveBit;
  export let onCancelEdit;
</script>

<!-- Two independent forms with two independent save buttons. They used to share
     one bordered block at identical heading weight, which made it easy to fill
     one and press the other's button. -->
<section class="draft-editor draft-block" aria-label="Invoice details">
  <h3>Invoice details</h3>
  <div class="form-grid">
    <label>Title<input bind:value={draftTitle} maxlength="120" /></label>
    <label>Due date<input bind:value={draftDueDate} type="date" /></label>
    <label>Tax (%)<input bind:value={draftTaxPercent} min="0" max="100" step="0.01" type="number" /></label>
    <CurrencySelect bind:value={draftCurrency} disabled={currencyLocked} />
    <label>Asking rate ({draftCurrency})<input bind:value={draftMinimumRate} min="1" step="0.01" type="number" /></label>
  </div>
  <p class="quiet">
    Changing currency keeps the same numbers — $100 CAD becomes $100 USD, not the
    converted value. It re-denominates draft amounts; it does not convert them.
    Currency locks permanently when first issued.
  </p>
  <div class="button-row">
    <button class="primary" disabled={savingInvoiceDraft} type="button" on:click={onSaveDraft}>
      {savingInvoiceDraft ? 'Saving…' : 'Save invoice details'}
    </button>
  </div>
</section>

<section class="draft-editor draft-block" aria-label="Reported work">
  <h3>{editingHourBitId ? 'Edit this work item' : 'Add a work item'}</h3>
  <div class="form-grid">
    <label>Label<input bind:value={bitLabel} maxlength="120" placeholder="Postgres upgrade recovery" /></label>
    <label>Hours<input bind:value={bitHours} min="0.001" max="10000" step="0.25" type="number" /></label>
    <label>Fixed cost ({draftCurrency})<input bind:value={bitFixedCost} min="0" step="0.01" type="number" /></label>
  </div>
  <p class="quiet">
    A fixed cost is a one-off you paid for on this item — materials, a licence. It
    travels with the item and is separate from anything a payer adds later.
  </p>
  <label>Description<textarea bind:value={bitDescription} maxlength="500" rows="3"></textarea></label>
  <label class="inline-check">
    <input bind:checked={bitReported} type="checkbox" />
    Ready to fund — payers can see and pay for this once the invoice is issued
  </label>
  <div class="button-row">
    <button class="primary" disabled={savingHourBit} type="button" on:click={onSaveBit}>
      {savingHourBit ? 'Saving…' : editingHourBitId ? 'Save work item' : 'Add work item'}
    </button>
    {#if editingHourBitId}
      <button type="button" on:click={onCancelEdit}>Cancel</button>
    {/if}
  </div>
</section>
